import React, { useState, useEffect } from "react";
import Header from "../../../Components/Header";
import Seo from "../../../Components/SeoComponent/Seo";
import { showSuccessToast, showErrorToast } from "../../../utils/toastUtils";
import { fetchProfile } from "../../../Services/ApiTestService/aadharTestService";
import { verifyEmailcheck } from "../../../Services/ApiTestService/apiTestService";
import { InputWithLabel, Button, SelectWithLabelOption } from "../../../Components/Tags/Tags";
import Loader from "../../../Loader";
import { Data4 } from "../Data";
import { Link } from "react-router-dom";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import RequesterMultiSelect from "../RequesterMultiSelect";
import { useService } from "../../../context/ServiceContext";


const EmailCheck = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [emailData, setEmailData] = useState({});
  const [errors, setErrors] = useState({});
  const [profileData, setProfileData] = useState({});
  const [email, setEmail] = useState("");
  const [reqService,setReqService] = useState("");
  const { serviceName } = useService();
  // Fetch profile data on mount
  useEffect(() => { 
    const fetchProfileData = async () => {
      try {
        setIsLoading(true);
        const response = await fetchProfile();
        setProfileData(response.data);
      } catch (error) {
        console.error("Error fetching profile data:", error);
        showErrorToast("Failed to fetch profile data.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchProfileData();
  }, []);

  // Form validation
  const validateForm = (email) => {
    const errors = {};
  
    if (!email.trim()) {
      errors.email = "email is required.";
    }
      
   // Check if at least one service selected
  if (!reqService || reqService.length === 0) {
    errors.reqService = "Please select at least one service.";
  }

  return errors;
};

  

  const handleSubmit = async () => {
    const validationErrors = validateForm(email);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length > 0) return;
  
    try {
      setIsLoading(true);
  
      const response = await verifyEmailcheck({
        api_id: profileData?.user_id,
        api_key: profileData?.api_key,
        token_id: profileData?.token_id,
        email: email,
      requested_services: reqService.map((item) => String(item)),
      });

  
      const statusCode = response?.status?.code;
      const statusMessage = response?.status?.message || response?.message;
  
      if (statusCode === 200) {
        const emailDetails = response?.data;
  
        if (emailDetails && typeof emailDetails === "object") {
          setEmailData(emailDetails);
          showSuccessToast(statusMessage || "Email  Verified successfully.");
          setErrors({});
        } else {
          showErrorToast("Email details are missing or in an unexpected format.");
        }
      } 
      else {
        // In all other error cases, show the message
        const errorMessage = response?.message || response?.data?.message || statusMessage || `Something went wrong. (code: ${statusCode})`;
        showErrorToast(errorMessage);
      }
  
    } catch (error) {
      console.error("Verify Email Error:", error);
      showErrorToast("Failed to verify Email details. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };
  

  return (
    <>
      <Seo />
      {isLoading && <Loader />}
      <Header heading={serviceName} />

      <div className="grid grid-cols-2 md:grid-cols-4 gap-2 justify-center md:ml-80 ml-0 p-4">
        
      <div className="col-span-2 md:col-span-6 flex justify-end">
  <Link
    to="/TestMaster"
    className="flex items-center gap-1 text-white bg-green-600 hover:bg-green-700 px-1 py-1 rounded-md font-semibold shadow-md transition duration-300"
  >
    <span>Go Back</span>
    <IoArrowBackCircleOutline size={24} />
  </Link>
</div>

        <InputWithLabel
          type="email"
          label="Email ID"
          className="p-0 rounded shadow-lg shadow-blue-500/50 border border-blue-600"
          name="email"
          id="email"
          required={true}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          error={errors.email}
        />

      <RequesterMultiSelect
  label="Requester Name"
  selectedValues={reqService}
  setSelectedValues={setReqService}
     error={errors.reqService}
/>

        <div>
          <Button
            type="button"
            className="text-center text-white bg-blue-900 shadow-lg bg-gradient-to-r from-blue-400 via-blue-1200 to-blue-900 font-semibold rounded-md px-2 py-1 mt-5 text-md hover:from-blue-900 hover:to-blue-400 border-4 ms-2"
            id="verifyMob"
            name="verifyMob"
            text="Verify"
            onClick={handleSubmit}
          />
        </div>
      </div>

      {emailData && Object.keys(emailData).length > 0 && (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 px-4 my-4">

    {/* First Half - JSON Response */}
    <div className="bg-white border border-yellow-300 rounded-md shadow-lg p-4 overflow-auto max-h-96">
      <h2 className="text-lg font-semibold text-yellow-800 mb-3">Raw Response (JSON)</h2>
      <pre className="text-sm bg-gray-100 p-2 rounded-md">{JSON.stringify(emailData, null, 2)}</pre>
    </div>

    {/* Second Half - Bank Details */}
<div className="bg-white border border-green-300 rounded-md shadow-lg p-4 mt-4">
  <h2 className="text-lg font-semibold text-green-800 mb-3">Details</h2>

  {emailData ? (
    <div className="text-gray-800 text-sm">
      <p>
        <strong>Message:</strong> {emailData.message || "-"}
      </p>
      <p>
        <strong>Status:</strong> {emailData.status || "-"}
      </p>
      <p>
        <strong>Email:</strong> {emailData.email || "-"}
      </p>
      <p>
        <strong>Client Ref No:</strong> {emailData.client_ref_num || "-"}
      </p>
      <p>
        <strong>Request ID:</strong> {emailData.request_id || "-"}
      </p>

      {/* Dynamic Model Summary */}
      {emailData.model?.summary && (
        <div className="mt-3">
          <h3 className="font-semibold text-green-700 mb-2">Requested Services</h3>
          <ul className="list-disc list-inside">
            {Object.entries(emailData.model.summary).map(([key, value]) => (
              <li key={key}>
                <strong>{key}:</strong> {value}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  ) : (
    <p className="text-gray-500 italic">No data available.</p>
  )}
</div>


  </div>
)}




    </>
  );
};

export default EmailCheck;
